import { render, staticRenderFns } from "./VLineBlock.vue?vue&type=template&id=524deb5a&scoped=true"
import script from "./VLineBlock.vue?vue&type=script&lang=js"
export * from "./VLineBlock.vue?vue&type=script&lang=js"
import style0 from "./VLineBlock.vue?vue&type=style&index=0&id=524deb5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524deb5a",
  null
  
)

export default component.exports